
import React, { useEffect, useState } from 'react';
import { Col, Row, Select } from 'antd';
import { useNavigate } from 'react-router-dom';
import { getAllPackageList } from '../../../services/holiday/holidayServices';
import { Holiday_Banner } from '../../../utils/ImagePath';


const HolidaySearch = () => {
  const [loading, setLoading] = useState(false);
  const [packageData, setPackageData] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchPackageData = async () => {
    setLoading(true);
    try {
      const response = await getAllPackageList();
      setPackageData(response?.data || []);
    } catch (err) {
      setError(err.message || 'An error occurred while fetching packages.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPackageData();
  }, []);


  const handleSearchChange = (value, option) => {
    const { type } = option;
    if (type === 'packages') {
      navigate(`/package-details/${value}`);
    } else if (type === 'destination') {
      navigate(`/destination/${value}`);
    } else if (type === 'package_category') {
      navigate(`/package/${value}`);
    }
  };

  const renderOptions = () => {
    return packageData.map((item) => ({
      value: item.slug,
      label: item.name,
      type: item.type,
    }));


  };


  return (

    <section className="HolidayBanner">
      <img loading="lazy" src={Holiday_Banner} alt="Holiday Banner" />
      <div className="container">
        <Row gutter={16} align="middle">
          <Col md={3}></Col>
          <Col md={18} sm={24}>
            <div className="holiday-cntr text-center">
              <h2>Book Holidays Packages</h2>
              <p className="mb-3">
                Take a break from the stress of everyday life, plan trips, and explore your favorite destination.
              </p>
            </div>
            <>
              <div className="d-flex justify-content-between align-items-center">
                <Select
                  className="form-control"
                  showSearch
                  placeholder="Search by Packages or Destinations"
                  optionFilterProp="label"
                  loading={loading}
                  onChange={handleSearchChange}
                  filterSort={(optionA, optionB) =>
                    (optionA.label || '').toLowerCase().localeCompare((optionB.label || '').toLowerCase())
                  }
                  options={renderOptions()}
                  aria-label="Search by Packages or Destinations"
                />
              </div>
            </>
            {error && <p style={{ color: 'red' }}>{error}</p>}
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default HolidaySearch;
